import { Entity } from "./entity";
import { BulletOwner } from "./types";
import { CONFIG, GameConfig } from "./config";

export class Bullet extends Entity {
  readonly owner: BulletOwner;
  dead = false;
  private speed: number;
  private cfg: GameConfig;

  constructor(x: number, y: number, owner: BulletOwner, cfg: GameConfig = CONFIG) {
    super(x, y, cfg.bullet.width, cfg.bullet.height);
    this.cfg = cfg;
    this.owner = owner;
    this.speed =
      owner === "player" ? -cfg.bullet.playerSpeed : cfg.bullet.invaderSpeed;
  }

  update(dt: number): void {
    this.y += this.speed * dt;
    if (this.y + this.height < 0 || this.y > this.cfg.canvas.height) {
      this.dead = true;
    }
  }

  draw(ctx: CanvasRenderingContext2D): void {
    ctx.fillStyle =
      this.owner === "player"
        ? this.cfg.colors.playerBullet
        : this.cfg.colors.invaderBullet;
    ctx.fillRect(this.x, this.y, this.width, this.height);
  }
}
